// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__sA-G7","body":"styles_body__iA8KX","options":"styles_options__SbUnb"};